// src/transport/registry.ts
var GRAPHQL_MASTER_FLAG = "graphql.enabled";
function flagForOperation(op) {
  return `graphql.${op}`;
}
var TRANSPORT_REGISTRY = {
  "catalog.list": { default: "rest" },
  "address.overlays": { default: "rest" },
  "address.detail": { default: "rest" },
  "transactions.recentFeed": { default: "rest" },
  "transactions.header": { default: "rest" },
  "address.assignments.list": { default: "rest" },
  "address.entityMapping.read": { default: "rest" },
  "address.assignments.write": { default: "rest" },
  "address.primary.write": { default: "rest" },
  "address.entityMapping.write": { default: "rest" }
};
function resolveTransport(op, flags, options = {}) {
  const graphqlConfigured = options.graphqlConfigured ?? true;
  if (!graphqlConfigured) return "rest";
  if (!flags.isEnabled(GRAPHQL_MASTER_FLAG)) return "rest";
  const entry = TRANSPORT_REGISTRY[op];
  const perOp = flagForOperation(op);
  if (flags.isEnabled(perOp)) return "graphql";
  return entry.default;
}
function usesGraphql(op, flags, options) {
  return resolveTransport(op, flags, options) === "graphql";
}

export { GRAPHQL_MASTER_FLAG, TRANSPORT_REGISTRY, flagForOperation, resolveTransport, usesGraphql };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map